import Route from '@ember/routing/route';

export default class EventWatchlistRoute extends Route {
  model() {
    // Get eventUuid from parent route
    const eventUuid = this.paramsFor('event').event_uuid;

    return {
      eventUuid
    };
  }
}
